import { createContext, useContext } from 'react';

export type SidebarContextType = {
  isCollapsed: boolean;
  expandedGroups: Record<string, boolean>;
  onGroupToggle: (groupId: string, expanded: boolean) => void;
  onToggleCollapse: () => void;
  hoveredGroupId: string | null;
  onGroupHover: (groupId: string | null) => void;
  focusedGroupId: string | null;
  onGroupFocus: (groupId: string | null) => void;
  activeSubmenuGroupId: string | null;
  onSubmenuActivate: (groupId: string | null) => void;
  resetKeyboardNav: () => void;
};

export const SidebarContext = createContext<SidebarContextType>({
  isCollapsed: false,
  expandedGroups: {},
  onGroupToggle: () => {},
  onToggleCollapse: () => {},
  hoveredGroupId: null,
  onGroupHover: () => {},
  focusedGroupId: null,
  onGroupFocus: () => {},
  activeSubmenuGroupId: null,
  onSubmenuActivate: () => {},
  resetKeyboardNav: () => {},
});

export const useSidebarContext = () => {
  return useContext(SidebarContext);
};
